export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/illustrative.1fbc16e.svg";